module.exports = __webpack_public_path__ + "static/img/train.201495dd.jpg";